module.exports = __webpack_public_path__ + "img/sendButton-disabled.eb7aade1.svg";